import { dateDifferenceCalculator } from "../helpers/common/dateDifferenceCalculator";
import { DateRangePeriod } from "../types";
let now = new Date(Date.now());
export const requestOptions = {
    from: dateDifferenceCalculator(now, DateRangePeriod.Last24Hours),
    to: now,
    locale: "en-EN"
};
//# sourceMappingURL=requestOptions.js.map